import type { CompanyMember } from '@/types/company.types'
import { userSubline } from '@/lib/formatters'

/** The member's user id, whether `userId` is a raw id or a populated object. */
export function getMemberId(m: CompanyMember): string {
  if (typeof m.userId === 'string') return m.userId
  return m.userId._id
}

/** Display name for a member, falling back to email then the raw id. */
export function getMemberLabel(m: CompanyMember): string {
  if (typeof m.userId === 'object' && m.userId !== null) {
    const { firstName, lastName, email } = m.userId
    const name = [firstName, lastName].filter(Boolean).join(' ').trim()
    return name || email || getMemberId(m)
  }
  return getMemberId(m)
}

/**
 * Small secondary line for a member dropdown. CompanyMember has no employee id,
 * so this is the email when the user is populated (undefined otherwise).
 */
export function getMemberSubline(m: CompanyMember): string | undefined {
  if (typeof m.userId === 'object' && m.userId !== null) {
    return userSubline(undefined, m.userId.email)
  }
  return undefined
}
